import { ActionType } from "../action-types";
import type { SignalREvent } from "../../signalr/types";
import {
  SignalRConnectingAction,
  SignalRConnectedAction,
  SignalRDisconnectedAction,
  SignalRErrorAction,
  SignalREventReceivedAction,
} from "../actions";

export const signalrConnecting = (): SignalRConnectingAction => ({
  type: ActionType.SIGNALR_CONNECTING,
});

export const signalrConnected = (): SignalRConnectedAction => ({
  type: ActionType.SIGNALR_CONNECTED,
});

export const signalrDisconnected = (): SignalRDisconnectedAction => ({
  type: ActionType.SIGNALR_DISCONNECTED,
});

export const signalrError = (msg: string | null): SignalRErrorAction => ({
  type: ActionType.SIGNALR_ERROR,
  payload: msg,
});

export const signalrEventReceived = (
  evt: SignalREvent
): SignalREventReceivedAction => ({
  type: ActionType.SIGNALR_EVENT_RECEIVED,
  payload: evt,
});
